/* Copyright (c) 2020-2024, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { StarfleetUser, SessionData } from '../starfleet.interface';

export const STARFLEET_LOGIN_URL_TEMPLATE_IMPLICIT_FLOW: string =
    ':server/authorize?response_mode=query&response_type=id_token+token&device_id=:deviceId' +
    '&scope=:scope&client_id=:clientId&redirect_uri=:redirectUri&ui_locales=:locale&nonce=:nonce' +
    '&prompt=select_account';

export const STARFLEET_LOGIN_URL_TEMPLATE_AUTHORIZATION_CODE_FLOW: string =
    ':server/authorize?response_type=code&device_id=:deviceId' +
    '&scope=:scope&client_id=:clientId&redirect_uri=:redirectUri&ui_locales=:locale&nonce=:nonce' +
    '&prompt=select_account&code_challenge=:codeChallenge&code_challenge_method=S256';

export const STARFLEET_LOGOUT_URL_TEMPLATE = ':server/logout?id_token_hint=:idToken&ui_locales=:locale';
export const STARFLEET_LOGOUT_URL_TEMPLATE_SAME_TAB =
    ':server/logout?id_token_hint=:idToken&ui_locales=:locale&post_logout_redirect_uri=:redirect_uri';

export const UnauthenticatedUser: StarfleetUser = {
    sub: '',
    idp_name: '',
    idp_id: '',
    external_id: '',
    preferred_username: '',
    consent: {
        trackTechnicalData: false,
        trackBehavioralData: false
    },
    isAuthenticated: false
};

export const UnauthenticatedSession: SessionData = {
    clientToken: null,
    accessToken: null,
    idToken: null,
    user: UnauthenticatedUser,
    clientTokenExpiry: null,
    accessTokenExpiry: null,
    idTokenExpiry: null
};

export const StarfleetAuthProvider = 'starfleet';

export enum StarfleetStoreDetails {
    DBName = 'starfleet',
    DBKey = 'starfleetSession'
}

export enum StorageType {
    SharedStorage = 'sharedStorage',
    IndexedDB = 'indexedDB'
}

export enum BridgeStateCloseResponse {
    Failure,
    Success,
    Cancel,
    CloseOnFailure
}
